module.exports = __webpack_public_path__ + "static/2014-layer-2-81fd56303a8591f31fb4ead8fbe1f53c.png";